const APIkey = 'd55f68ca428d8ef286807aa18e15f3db';
const dayString = {
	weekday: 'long'
}
const dateString = {
	day: 'numeric',
	month: 'long',
	year: 'numeric',
}

const noGeoloc = document.getElementsByClassName('noGeoloc');


if('geolocation' in navigator) {
	navigator.geolocation.getCurrentPosition(position => {
		noGeoloc[0].classList.remove('show');
		document.getElementById('meteo').classList.add('show');
		displayLocationInfo(position.coords.latitude, position.coords.longitude);
		getWeatherByCoordinates(position.coords.latitude, position.coords.longitude);
	}, function() {
		console.log('Géoloc refusée');
	});
}
document.getElementById('formNogeoloc').addEventListener('submit', function(e) {
	e.preventDefault();
	noGeoloc[0].classList.remove('show');
	document.getElementById('meteo').classList.add('show');
	getLocationInfo(e.target.children.searchCity.value);
})
document.getElementById('formCity').addEventListener('submit', function(e) {
	e.preventDefault();
	getLocationInfo(e.target.children.city.value);
	e.target.children.city.value = '';
})


const getLocationInfo = function(city) {
	fetch('https://api.openweathermap.org/geo/1.0/direct?q='+ city +'&appid=' + APIkey)
		.then(res => {
			if(res.ok) {
				return res.json();
			} else {
				document.getElementById('errorCity').classList.add('active');
			}
		})
		.then(data => {
			document.getElementById('locationInfo').innerHTML = data[0].name + ', <span class="meteo__main__country">'+ data[0].country +'</span>';
			getWeatherByCoordinates(data[0].lat, data[0].lon);
		})
}

const displayLocationInfo = function(lat, lon) {
	fetch('https://api.openweathermap.org/geo/1.0/reverse?lat='+ lat +'&lon='+ lon +'&appid=' + APIkey)
		.then(res => {
			if(res.ok) {
				return res.json();
			} else {
				alert('Ville introuvable');
			}
		})
		.then(data => document.getElementById('locationInfo').innerHTML = data[0].name + ', <span class="meteo__main__country">'+ data[0].country +'</span>')
}

const getWeatherByCoordinates = function(lat, lon) {

	fetch('https://api.openweathermap.org/data/2.5/onecall?lat='+ lat +'&lon='+ lon +'&lang=fr&units=metric&exclude=minutely,hourly,alerts&appid='+ APIkey)
		.then(res => res.json())
		.then(data => {
			displayMainWeather(data.current);
			displayForecastWeather(data.daily);
		})

}

const displayMainWeather = function(weatherInfo) {

	const date = new Date(weatherInfo.dt*1000);

	document.getElementById('errorCity').classList.remove('active');
	document.getElementById('date').innerHTML = 
	`
		<span class="meteo__main__day">${date.toLocaleDateString('fr-FR', dayString)}</span>
		<span class="meteo__main__fullDate">${date.toLocaleDateString('fr-FR', dateString)}</span>
	`;
	document.getElementById('mainIcon').src = `https://openweathermap.org/img/wn/${weatherInfo.weather[0].icon}@2x.png`;
	document.getElementById('temperature').innerHTML = Math.round(weatherInfo.temp) + '°C';
	document.getElementById('feelTemperature').innerHTML = Math.round(weatherInfo.feels_like) + '°C';
	document.getElementById('weatherType').innerHTML = weatherInfo.weather[0].description;

	document.getElementById('humidity').innerText = weatherInfo.humidity;
	document.getElementById('wind').innerText = Math.round(weatherInfo.wind_speed * 3.6);

}

const displayForecastWeather = function(forecastWeather) {

	const forecastWrapper = document.getElementById('forecast');
	forecastWrapper.innerHTML = '';
	const weathers = forecastWeather.slice(1, 6);

	weathers.forEach((element, index) => {
		const date = new Date(element.dt*1000);
		
		forecastWrapper.innerHTML +=
		`
		<li class="meteo__forecast__item" data-index="${index}">
			<span class="meteo__forecast__item__date">${date.toLocaleDateString('fr-FR', {day: 'numeric', month: 'short'})}</span>
			<figure class="meteo__forecast__item__img"><img src="https://openweathermap.org/img/wn/${element.weather[0].icon}.png" alt="icon"></figure>
			<span class="meteo__forecast__item__temp">${Math.round(element.temp.day)} °C</span>
			<span class="meteo__forecast__item__minMax">${Math.round(element.temp.min)} °C/${Math.round(element.temp.max)} °C</span>
		</li>
		`;
	});

}